import { useState } from "react";
import { toast } from "sonner";
import { Layers } from "lucide-react";
import { CompanyModulesPicker } from "@/components/CompanyModulesPicker";
import { useCompany } from "@/context/CompanyContext";
import { api } from "@/lib/api";
import { modulesOf, modulesSummary } from "@/lib/modules";

// Settings: add or remove features as the business grows. Each tick saves straight away.
export const CompanyModulesSection = () => {
  const { company, setCompany } = useCompany();
  const [busy, setBusy] = useState(false);
  const change = async (modules) => {
    setBusy(true);
    try { const c = await api.updateCompany({ modules }); setCompany(c); toast.success(`Now using: ${modulesSummary(c.modules)}`); }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not change your features"); }
    finally { setBusy(false); }
  };
  return (
    <div className="rounded-lg border border-border p-4 space-y-3" data-testid="company-modules-section">
      <div>
        <p className="text-sm font-medium flex items-center gap-2"><Layers className="w-4 h-4 text-primary" /> Features</p>
        <p className="text-xs text-muted-foreground">Add or remove features as you go. Turning one off only hides it; your data is kept.</p>
      </div>
      <CompanyModulesPicker value={modulesOf(company)} onChange={change} disabled={busy} />
    </div>
  );
};
